(function() {
  if (!window.fetch) return;

  function showToast() {
    var toast = document.getElementById('add-to-cart-toast');
    if (!toast) return;

    toast.classList.remove('hidden');
    toast.classList.add('visible');

    setTimeout(function() {
      toast.classList.remove('visible');
      toast.classList.add('hidden');
    }, 3000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.js-cart-count').forEach(function(el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); });
  }

  function showViewCartButton(form) {
    if (!form) return;

    var textEl = form.querySelector('.js-product-add-text');
    if (!textEl) return;

    textEl.textContent = 'View cart';

    var button = textEl.closest('button') || textEl;
    var cartUrl = (window.theme && theme.routes && theme.routes.cartUrl) || '/cart';

    button.addEventListener('click', function(event) {
      event.preventDefault();
      window.location.href = cartUrl;
    }, { once: true });
  }

  function trackAddToCart() {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'add_to_cart' });
    }
  }

  function handleSuccessfulAdd(form) {
    showToast();
    refreshCartCount();
    showViewCartButton(form);
    trackAddToCart();
  }

  function handleAddToCart(event) {
    var form = event.target;
    if (!form.matches('form[action^="/cart/add"]')) return;

    event.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function(response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    }).then(function() {
      handleSuccessfulAdd(form);
    }).catch(function() {
      form.submit();
    });
  }

  if (window.ajaxCart && window.theme && theme.cart_ajax && window.jQuery) {
    jQuery(function($) {
      $(document.body).on('afterAddItem.ajaxCart', function(_, _item, form) {
        handleSuccessfulAdd(form);
      });
    });
  } else {
    document.addEventListener('submit', handleAddToCart);
  }
})();
